// ─── File Format Compatibility ──────────────────────────────────────
//
// Shared between @papan/collab (registers binary extensions via editor
// plugin registry) and @papan/files (checks compatibility on rename).
// Lives in @papan/types to avoid circular dependencies.

/** Set of extensions that are binary formats, populated by editor registrations */
const binarySet = new Set<string>()

/** Called by editor registrations to declare binary extensions */
export function registerBinaryExtensions(extensions: string[]): void {
  for (const ext of extensions) {
    binarySet.add(ext.toLowerCase())
  }
}

/** Check if two extensions are compatible for renaming (text↔binary = incompatible) */
export function areExtensionsCompatible(oldExt: string, newExt: string): boolean {
  const a = oldExt.toLowerCase()
  const b = newExt.toLowerCase()
  if (a === b) return true
  return binarySet.has(a) === binarySet.has(b)
}
